import React, {PropsWithChildren} from 'react';

export const Visibility: React.FC<
  PropsWithChildren<{
    visible?: boolean;
    replacement?: React.ReactNode;
  }>
> = ({children, visible = true, replacement}) => {
  if (!visible) return <>{replacement ?? <div key={'replacement'} />}</>;
  return <>{children}</>;
};
